export default {
  "fr": {
    "sentence_type_risk": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["RISQUE"])},
    "sentence_type_opportunity": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["OPPORTUNITÉ"])},
    "sentence_type_in_my_network": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DANS MON RÉSEAU"])}
  },
  "en": {
    
  }
}